/**
 * Alif Installment Plan - Cart Price Calculator
 * 
 * This script automatically calculates and updates the installment price
 * based on the cart total. It runs every second to ensure real-time updates.
 * 
 * IMPORTANT: Replace ".t4s-cart__totalPrice" with your theme's cart total element class
 */

function calculateInstallment() {
    // Select the element with data attribute 'data-subtotal'
    // TODO: Replace ".t4s-cart__totalPrice" with your theme's cart total element class
    const cartSubtotalDiv = document.querySelector("span.price-item.price-item--sale.price-item--last");
    
    // Check if the element exists
    if (cartSubtotalDiv) {
      const cartTotalText = cartSubtotalDiv.textContent;
      
      if (cartTotalText) {
        // Clean the cart total text
        const cleanedCartTotalText = cartTotalText
          .replace(/[^0-9.]/g, "")
          .replace(/^\.+/, "");
        
        const cartPageTotal = parseFloat(cleanedCartTotalText);
        
        // Only proceed if we have a valid cart total (greater than 0)
        if (cartPageTotal > 0) {
          // Calculate the final cart price (divided by 3 for installments)
          const finalCartPrice = Math.floor(cartPageTotal / 3);
          
          // Only update if the calculated price is greater than 0
          if (finalCartPrice > 0) {
            // Get currency from sessionStorage (set in liquid file)
            const currency = sessionStorage.getItem("currency") || "Rs.";
            
            // Select the element to display the installment price
            const priceDiv = document.querySelector(".alif-price-divide");
            
            if (priceDiv) {
              // Format and display the installment price
              priceDiv.textContent = currency + finalCartPrice.toLocaleString();
            }
          }
        }
      }
    }
    
    // Call the function again after 1 second for real-time updates
    setTimeout(calculateInstallment, 1000);
  }
  
  // Initial call to the function when the page loads
  calculateInstallment();
  
  